export const generateCourierPayload = (order) => {
  if (!order) {
    console.error("❌ No order provided.");
    return null;
  }

  if (!order.shipcluesId) {
    console.error("❌ Missing shipcluesId in order:", order);
    return null;
  }

  return {
    order_id: order.shipcluesId
  };
};